import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VMEvent, Line } from './config.model'
import EventService from './event.service'
import Visible from "../../directives/visible";

@Component({
    name: 'config',
    directives: {
        Visible,
    },
})
export default class ConfigComponent extends Vue {
    service: EventService = new EventService();
    eventsPage: VMEvent[] = [];
    selectedIndex: VMEvent[] = [];
    newEvent: VMEvent = new VMEvent();

    columnsConfig = [
        {
            label: 'Name',
            field: 'name',
        },
    ];
    selectConfig = {
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: this.getSelectionTextStr(),
        clearSelectionText: this.getClearStr(),
        disableSelectInfo: false, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };

    constructor() {
        super();
        this.selectedIndex = [];
    }

    mounted() {
        this.fetchEvents();
    }

    selectionChanged(params) {
        console.log("selection event=" + JSON.stringify(params));
        this.selectedIndex = params.selectedRows;
        // params.selectedRows - all rows that are selected (this page)
    }

    getClearStr() {
        return this.$i18n.t('comClear').toString();
    }

    getSelectionTextStr() {
        return this.$i18n.t('comSelectionCnt').toString();
    }

    fetchEvents() {
        this.service.fetchEvents()
            .then(data => {
                this.eventsPage = data as VMEvent[];
                console.log(this.eventsPage);
            });
    }

    postEvent() {
        this.service.postEvent(this.newEvent);
        this.fetchAndClear();
    }

    deleteSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.deleteEvents(this.selectedIndex);
            this.fetchAndClear();
        }
    }

    updateSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.updateEvent(this.selectedIndex[0]);
            this.fetchAndClear();
        }
    }

    clearSelection() {
        this.selectedIndex = [];
    }

    // Fetches the data after 1 second and also clears the inputs etc.s
    fetchAndClear() {
        // Create a new Promise and resolve after 1 seconds
        var myTimerPromise = new Promise((resolve, reject) => {
            setTimeout(resolve, 500);  // "resolve" is already a function, no need for another anonymous function here
        });

        // Fetch data now, within Promise.all()
        Promise.all([myTimerPromise]).then(() => {
            this.fetchEvents();
            this.clearSelection();
            this.newEvent = new VMEvent();
        });
    }
}